<mat-expansion-panel *ngIf="user" class="app-menu-container">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <small i18n>USER ID {{user.username}}</small>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <p i18n>NAME {{fullName}}</p>
  <div>
    <button mat-icon-button [matMenuTriggerFor]="menu" i18n-title title="Change system language">
      <mat-icon>language</mat-icon>
    </button>
    <button mat-icon-button (click)="openSettings()" mat-button i18n-title title="Change system settings">
      <mat-icon>settings</mat-icon>
    </button>
    <app-help topic="HOME"></app-help>
    <span fxFlex></span>
    <a href="signin/" mat-button i18n>
      LOGOUT
    </a>
  </div>
</mat-expansion-panel>

<mat-menu #menu="matMenu">
  <a mat-menu-item href="/en/" fxLayoutGap="16px" [disabled]="locale.startsWith('en')">
    <span fxFlex i18n>English</span>
    <small>en</small>
  </a>
  <a mat-menu-item href="/pt/" fxLayoutGap="16px" [disabled]="locale.startsWith('pt')">
    <span fxFlex i18n>Portuguese</span>
    <small>pt</small>
  </a>
</mat-menu>
